import apiService from "./apiService";

export const requestViberPrescription = (page) => {
  let queryParams = {
    page: page ?? 1,
    item_per_page:10
  };
  return apiService.get(URIS.viberPrescription,{params:queryParams});
}

export const requestUpdateName = ({id, payload}) => {
  return apiService.put(URIS_D('updateName', id),payload);
}

export const requestCreateOrder = (payload) => {
  return apiService.post(URIS.botAction, payload);
}

export const requestScannedOrder = (payload) => {
  return apiService.get(URIS.scannedOrder, {params: payload})
}

export const requestPharmacyPrescription = (prescriptionId) => {
  return apiService.get(URIS_D('prescription',prescriptionId));
}

export const requestProductInfoGet = (query) => {
  let queryParams = {
    search:query,
    brief_search:true,
    narcotic:true,
    variant:true
  };
  return apiService.get(URIS.productSearch,{params:queryParams});
}

export const requestCreatePrescription = ({orderId, payload}) => {
  return apiService.post(URIS_D('createPrescriptions', orderId), payload);
}

export const requestDeletePrescription = ({orderId, prescriptionId}) => {
  return apiService.delete(URIS_D('deletePrescription', orderId, prescriptionId))
}

export const requestSendQuotation = (orderId) => {
  return apiService.post(URIS_D('sendQuotation', orderId))
}

export const requestConfirmOrder = ({ prescriptionId, payload}) => {
  return apiService.post(URIS_D('confirmOrder', prescriptionId), payload)
}

export const requestCancelOrder = ({ prescriptionId, payload}) => {
  return apiService.patch(URIS_D('cancelOrder', prescriptionId), payload)
}

export const requestUpdateAddress = ({addressId, address}) => {
  return apiService.put(URIS_D('updateAddress', addressId), address)
}

const URIS_D = (url, param1, param2='') => {
  return {
    deletePharmacist: `/admin/promotional-events/${param1}`,
    updateName: `/v1/pharmacy/bot-customers/${param1}`,
    prescription: `/pharmacy/prescriptions/${param1}`,
    createPrescriptions: `/pharmacy/orders/${param1}/prescriptions`,
    deletePrescription:`/pharmacy/orders/${param1}/prescriptions/${param2}`,
    sendQuotation: `/pharmacy/orders/${param1}/prescriptions/complete`,
    confirmOrder: `/pharmacy/prescriptions/${param1}/orders`,
    cancelOrder: `/pharmacy/prescriptions/${param1}`,
    updateAddress: `/user-profile/addresses/${param1}`
  }[url]
}

const URIS = {
  viberPrescription: `/v1/callbacks/viber`,
  scannedOrder: `/pharmacy/orders`,
  botAction: `/v1/pharmacy/bot-customers`,
  productSearch: `/products`
}
